import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Järelmaks kuus al.

  <span style="color:#85c1dc;">**FI:**</span>
  Osamaksu alkaen

  <span style="color:#85c1dc;">**RU:**</span>
  Рассрочка в месяц от
*/
/* @__NO_SIDE_EFFECTS__ */
const m1538 = msg(
  mf`Järelmaks kuus al.`,
  mf`Osamaksu alkaen`,
  mf`Рассрочка в месяц от`,
)

export { m1538 as 'w.module.product_hero.monthly_price' }